import { env } from "@/constants/env";
import { syncMetaTrackingStatus } from "@/utils/meta-app-events";
import { Capacitor } from "@capacitor/core";
import { AppTrackingTransparency } from "capacitor-plugin-app-tracking-transparency";

const readTrackingPermission = async () => {
  if (env.MODE !== "production") return false;
  if (Capacitor.getPlatform() !== "ios") return true;

  try {
    const { status } = await AppTrackingTransparency.getStatus();
    if (status === "authorized") return true;
    if (status !== "notDetermined") return false;

    const permissionResult = await AppTrackingTransparency.requestPermission();
    return permissionResult.status === "authorized";
  } catch (error) {
    console.warn("[Tracking] Failed to resolve ATT status", error);
    return false;
  } finally {
    // Refresh native ATT after the prompt callback, including iOS resume/callback races.
    // Do not delay analytics or startup on the advertising bridge.
    void syncMetaTrackingStatus();
    window.dispatchEvent(new Event("nutricoach:tracking-status-changed"));
  }
};

// Permission policy is launch-scoped, matching existing behaviour. A remount must
// not open a second ATT prompt. Runtime policy changes belong to a future rollout.
let permission: Promise<boolean> | undefined;
export const resolveTrackingPermission = () => (permission ??= readTrackingPermission());

// Mixpanel collection is independent of Apple's advertising-tracking permission.
export const isMixpanelEnabled = () => env.MODE === "production";

export const resolveTrackingPolicy = async () => {
  const enabled = await resolveTrackingPermission();
  return { productAnalyticsEnabled: isMixpanelEnabled(), replayEnabled: enabled };
};
